import React, { Component } from 'react'
import View from './view'

export default class CTA extends Component {
  handleClick = () => {
    const { fields } = this.props
    if( fields ){
      ga( "send", "event", fields )
    }
  }
  render(){
    const { className, children, id, url, target } = this.props
    return (
      <View
        className={ className }
        id={ id }
        url={ url }
        target={ target }
        handleClick={ this.handleClick }
        children={ children }
      />
    )
  }
}
